//React
//Components
import {
  Button,
  FlexBox,
  Image,
  Input,
  Modal,
  Screen,
  TranslatedString,
} from "components";
import React, { useEffect, useState } from "react";
import ROUTE_PATH from "Routes/paths";
import { setGeneralDetails, useGeneralDetails } from "Slices";
//Utils
import {
  ChangeHistory,
  EventManager,
  EventNames,
  getURLParameter,
  validateEmail,
} from "utils";
//Styles
import "./styles.scss";
//Libraries
import cx from "classnames";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
//Assets
import BharatPeLogo from "assets/company logos/bharatpe.svg";
import BillBookLogo from "assets/company logos/billbook.svg";
import DstreetLogo from "assets/company logos/dstreet-finance-logo-white.svg";
import ElectricpeLogo from "assets/company logos/electricpe.svg";
import RiveLogo from "assets/company logos/rive-temp-logo.svg";
import SecureNowLogo from "assets/company logos/secure now.png";
import StraightLineLogo from "assets/company logos/Straight-Line-Logo-Blue.svg";
import ZtockLogo from "assets/company logos/ztocks-logo.png";
import PostPeLogo from "assets/company logos/postpe.svg";
import ParkLogo from "assets/company logos/park.svg";
import CapriLogo from "assets/company logos/capri.svg";
import CootzLogo from "assets/company logos/cootz.svg";
import SayFLogo from "assets/company logos/sayf.svg";
import ShopifyLogo from "assets/platforms/shopify.png";
import WordpressLogo from "assets/platforms/wordpress.png";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";

const Landing = () => {
  const [emailValue, setEmailValue] = useState("");
  const [iframeSrc, setIframeSrc] = useState("");
  const [iframeModalVisiblity, setIframeModalVisiblity] = useState(false);
  const [showButtonLoader, setButtonShowLoader] = useState(false);
  useEffect(() => {
    window.addEventListener("message", receiveMessage, false);
  }, []);

  const receiveMessage = (event) => {
    const data = event.data;
    switch (data.action) {
      case "sessionLink":
        window.open(data.sessionLink, "_self");
        setButtonShowLoader(false);
        setIframeSrc("");
        break;

      case "messageSent":
        // setIframeModalVisiblity(false);
        // setEmailValue("");
        // setIframeSrc("");
        // setButtonShowLoader(false);
        ChangeHistory("push", ROUTE_PATH.PLATFORM.HOME);
        break;

      default:
        break;
    }
  };

  //Return UI
  return (
    <Screen
      className="mobile-website-screen"
      hasHeader
      screenAnimationClass="no-animation"
    >
      <FlexBox
        justifyAround
        alignCenter
        flexColumn
        className="middle-section pd-20 text-center"
      >
        <div className="top-text">
          <p className="fs-28 font-heavy">
            Add <span className="clr-theme">WhatsApp</span>{" "}
            <span className="clr-theme">login</span> <br /> to your app/website
          </p>
          <p className="fs-18 mr-t-10 caption">
            Free forever for unlimited users
          </p>
        </div>
        <FlexBox
          flexColumn
          alignCenter
          className="animated fadeInDown delay-2-5s"
        >
          <Carousel
            autoPlay
            infiniteLoop
            showArrows={false}
            showStatus={false}
            showIndicators={false}
            showThumbs={false}
            className="animated fadeInDown delay-01s"
          >
            <Image src={BharatPeLogo} />
            <Image src={BillBookLogo} className="bill-book" />
            <Image src={ShopifyLogo} />
            <Image src={WordpressLogo} />
            <Image src={DstreetLogo} />
            <Image src={ElectricpeLogo} />
            <Image src={RiveLogo} />
            <Image src={SecureNowLogo} />
            <Image src={StraightLineLogo} />
            <Image src={ZtockLogo} />
            <Image src={PostPeLogo} />
            <Image src={ParkLogo} />
            <Image src={CapriLogo} />
            <Image src={CootzLogo} />
            <Image src={SayFLogo} className="bill-book" />
          </Carousel>
          {/* <Image src={BharatPeLogo} className="w-50" /> */}
          <div className="animated fadeInDown delay-03s">
            <p className="font-medium fs-22">10 million happy users</p>
            <p>⭐ ⭐ ⭐ ⭐ ⭐</p>
          </div>
        </FlexBox>
      </FlexBox>
      <FlexBox
        justifyBetween
        flexColumn
        className="bottom-section clr-white pd-20 animated fadeInUp delay-3s"
      >
        <p className="fs-20 font-medium">Get Started</p>
        <Input
          type="email"
          onChange={({ target }) => {
            setEmailValue(target.value);
          }}
          value={emailValue}
          placeholder="Enter your email address"
        />
        <Button
          text={
            showButtonLoader ? (
              <FlexBox alignCenter justifyCenter>
                <div className="loader"></div>
              </FlexBox>
            ) : (
              <FlexBox alignCenter justifyCenter className="cta-text">
                <p className="font-medium">Continue with WhatsApp</p>
              </FlexBox>
            )
          }
          className="w-100 fs-16 mr-t-10"
          onClick={() => {
            if (validateEmail(emailValue)) {
              setButtonShowLoader(true);
              window
                .fetch("https://metaverse.otpless.app/v1/merchant/verify", {
                  headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                  method: "POST",
                  body: JSON.stringify({
                    email: emailValue,
                    utm: window.location.href,
                    utmSource: getURLParameter("utm_source"),
                    utmMedium: getURLParameter("utm_medium"),
                    utmCampaign: getURLParameter("utm_campaign"),
                    utmCreative: getURLParameter("utm_creative"),
                  }),
                })
                .then((res) => res.json())
                .then((data) => {
                  if (data.success) {
                    EventManager.send(
                      EventNames.EVENTS_NAME.WEBSITE.NEW_LANDING.INTEGRATE,
                      {
                        utm: window.location.href,
                        utm_source: getURLParameter("utm_source"),
                        utm_medium: getURLParameter("utm_medium"),
                        utm_campaign: getURLParameter("utm_campaign"),
                      }
                    );
                    secureLocalStorage.setItem("mid", data?.data?.mid);
                    setIframeSrc(
                      `https://otpless.authlink.me/whatsappAuth?email=${emailValue}&flow=IFRAME&redirectURI=${encodeURIComponent(
                        window.location.href
                      )}`
                    );
                    setIframeModalVisiblity(window.screen.width > 768);
                  } else {
                    setButtonShowLoader(false);
                    toast.error("Please enter valid work email");
                  }
                });
            } else {
              toast.error("Please enter valid work email");
            }
          }}
          disabled={showButtonLoader}
        />
        <Modal
          visible={iframeModalVisiblity}
          className="iframe-modal"
          onClose={() => {
            setIframeModalVisiblity(false);
            setIframeSrc("");
          }}
        >
          <iframe src={iframeSrc} hidden={window.screen.width < 768} />
        </Modal>
      </FlexBox>
    </Screen>
  );
};

export default Landing;
